﻿import { OfflineDebateSessionFile } from "./offline-debate-session-file";
import { OfflineDebateSessionQuestionAnswer } from "./offline-debate-session-question-answer";

export class OfflineDebateSessionDetail {
    id: number;
    debateId: number;
    date: Date;
    startTime: Date;
    endTime: Date;
    location: string;
    type: string;
    numberOfParticipants: number;
    status: string;
    description: string;
    finalReport: string;
    numberOfMaleParticipants: number;
    numberOfFemaleParticipants: number;
    active: boolean;
    files: Array<OfflineDebateSessionFile>;
    questionAnswers: Array<OfflineDebateSessionQuestionAnswer>;
}